import styled from 'styled-components';
import { BUTTON_ICONS } from '../../../shared/common/Button/Icon';
import { StCampaignMetaLabel, StCampaignMetaValue, StEditIcon } from './MetaDataStyles';
import { useTranslation } from 'react-i18next';

const StTagLineContainer = styled.div`
    font-size: 15px;
    max-width: 30vw;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: bottom;
`;

interface Props {
    icon: (typeof BUTTON_ICONS)[number];
    onEditButtonClick: () => void;
    tagLineContent: string;
    editAllowed: boolean;
    grayingProductListItem: boolean;
}

export const TagLine = (props: Props) => {
    const { t } = useTranslation();
    const { icon, onEditButtonClick, tagLineContent, editAllowed, grayingProductListItem } = props;

    return (
        <div data-testid="tagline">
            <StCampaignMetaLabel>{t('marketing.yourCampaigns.campaignTagLine')}:</StCampaignMetaLabel>
            <StTagLineContainer title={!grayingProductListItem ? tagLineContent : ''}>
                <StCampaignMetaValue>
                    {tagLineContent ? tagLineContent : t('marketing.yourCampaigns.none')}
                </StCampaignMetaValue>
            </StTagLineContainer>
            {editAllowed ? (
                <span>
                    <StEditIcon onClick={onEditButtonClick} icon={icon} />
                </span>
            ) : null}
        </div>
    );
};
